// Module
var code = "<div class=bible> <h2 class=passageref>Mark 3.20-21</h2> <div class=bibletext> <p> <sup class=ww>20</sup>and the crowd came together again, so that they could not even eat. <sup class=ww>21</sup>When his family heard it, they went out to restrain him, for people were saying, &#145;He has gone out of his mind.&#146; </p> </div></div>";
// Exports
module.exports = code;